import { render, staticRenderFns } from "./TeamForm.vue?vue&type=template&id=745f4485&scoped=true&"
import script from "./TeamForm.vue?vue&type=script&lang=js&"
export * from "./TeamForm.vue?vue&type=script&lang=js&"
import style0 from "./TeamForm.vue?vue&type=style&index=0&id=745f4485&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745f4485",
  null
  
)

export default component.exports